console.log("Bild URL in BILD umwandel FAQ");

// Alle FAQ-Abschnitte durchsuchen
document.querySelectorAll(".rte, .faq-content, p").forEach(container => {
  container.querySelectorAll("a").forEach(link => {
    const url = link.href;

    // Prüfen, ob Link auf Bilddatei endet
    if(url.match(/\.(jpeg|jpg|gif|png|webp)(\?.*)?$/i)) {

      // Prüfen, ob wir das Bild schon hinzugefügt haben
      if(!link.dataset.processed) {
        const img = document.createElement("img");
        img.src = url;
        img.style.maxWidth = "100%";  // passt sich Container an
        img.style.height = "auto";
        img.style.display = "block";
        img.style.marginTop = "10px";
        img.style.marginBottom = "10px";

        // Link durch Bild ersetzen
        link.parentNode.replaceChild(img, link);

        // Markieren, damit nicht doppelt
        link.dataset.processed = "true";
      }
    }
  });
});

